//import React, { useState } from "react";
import React from "react";
//import { Container, Row,Col ,Form, Button} from "react-bootstrap";
import { Col ,Form, Button} from "react-bootstrap";

import fbook from "../content/flogo.png";
class ContactForm extends React.Component {
  async sendMsg(e){
    try{
    e.preventDefault();
    const {Cname,Cemail,Cnumber,Cmsg}= e.target.elements;
    console.log(Cmsg.value)
    let details={
        site:"UVGrade",
        name:Cname.value,
        email:Cemail.value,
        phone:Cnumber.value,
        message:Cmsg.value
    }
    let response = await fetch("https://mdqzrv338i.execute-api.us-east-1.amazonaws.com/default/contactForm", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(details),
    });
    await response.json();
    alert("Message Sent, we'll be in touch!");
  }catch(e){
    alert("Whoops, couldn't send the message. Please try again later.");
  }
  }
  render() {
    return (
      <>
              <Col md={6} xs={12}> <br/>
            Email
            <br />
            <a href="info@uvgrade.com">info@uvgrade.com</a>
            <br />
            Find us on Social Media
            <br />
            <a href="https://www.facebook.com/UVGrade-793508880853758/">
              <img src={fbook} height="50px" alt="UVGrade" />
            </a>
              </Col>
              <Col md={6} xs={12} align="left">
                <Form onSubmit={this.sendMsg}>
                <Form.Group>
                  <Form.Label>Name:</Form.Label>
                  <Form.Control id="Cname" type="text" required/>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Email:</Form.Label>
                  <Form.Control id="Cemail" type="email" required/>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Phone:</Form.Label>
                  <Form.Control id="Cnumber" type="number" required/>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Message:</Form.Label>
                  <Form.Control id="Cmsg" as="textarea" rows={3} required/>
                </Form.Group>
                <Button id="formB" type="submit">Submit</Button>
              </Form>
              </Col>
            
            <br/><br/><br/><br/>
        </>
    );
  }
}
export default ContactForm;
